import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent } from "vue";
import { SvgIcon } from "@/components/index";
import headset from "@/assets/images/svg/headset.svg";
import { initializeIntercomWithCompanyData } from "@/utils/helpers/store";
import { LogLevel, LogService } from "@/services/logging";
import { ref } from "vue";
export default defineComponent({
  name: "Intercom",
  components: {
    SvgIcon: SvgIcon
  },
  setup: function setup() {
    var iconStyle = "filter: contrast(170%) invert(100%);";
    var iconContent = headset;
    var iconAlt = "Contact Support";
    var loading = ref(false); //

    function triggerIntercom() {
      return _triggerIntercom.apply(this, arguments);
    }

    function _triggerIntercom() {
      _triggerIntercom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!loading.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                // prevent double clicks
                loading.value = true;
                _context.prev = 3;

                if (!window.Intercom) {
                  _context.next = 11;
                  break;
                }

                LogService.info("Intercom already initialized, lets show it");
                console.log("------- Intercom already initialized, lets show it"); // If Intercom is already initialized, just show it
                // @ts-ignore

                window.Intercom("open");
                LogService.info("Intercom chatbot is now shown");
                _context.next = 18;
                break;

              case 11:
                // Initialize Intercom if not already initialized
                LogService.info("Initialize Intercom if not already initialized");
                _context.next = 14;
                return initializeIntercomWithCompanyData();

              case 14:
                LogService.info("Intercom is now initialized, lets show the chatbot"); // Show the Intercom widget
                // await new Promise((resolve) => setTimeout(resolve, 100));

                console.log("------ showing chatbot"); // @ts-ignore

                window.Intercom("show");
                LogService.info("Intercom chatbot is now shown");

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](3);
                console.error("Error triggering Intercom:", _context.t0);
                LogService.info("Error triggering Intercom", {
                  param: {
                    error: _context.t0
                  }
                }, LogLevel.Error);

              case 24:
                _context.prev = 24;
                loading.value = false;
                return _context.finish(24);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 20, 24, 27]]);
      }));
      return _triggerIntercom.apply(this, arguments);
    }

    return {
      iconContent: iconContent,
      iconAlt: iconAlt,
      iconStyle: iconStyle,
      triggerIntercom: triggerIntercom,
      loading: loading
    };
  }
});